import { InjectionToken } from "@angular/core";

import { QueryHub } from "../models/query-hub.interface";
import { QueryResolver } from "../models/query-resolver.interface";


export const QUERY_HUB = new InjectionToken<QueryHub>("QUERY_HUB");

export const QUERY_RESOLVER = new InjectionToken<QueryResolver>("QUERY_RESOLVER");
